module.exports = __webpack_public_path__ + "static/media/logo.01f141dd.svg";